import * as React from "react";
import Cards from "./Cards/Cards";
import MainMetricsAnalysisContent from "./MainMetricsAnalysisContent/MainMetricsAnalysisContent";

const MetricsAnalysis = ({ metricsAnalysis, analyses, variants, activities, totalCases }) => {
  return (
    <div className={'col-md-6'}>
      <Cards analyses={analyses} variants={variants} activities={activities} totalCases={totalCases} />
      <MainMetricsAnalysisContent data={metricsAnalysis}/>
    </div>
  )
}

export default MetricsAnalysis